<div class="subject-container">
  @if (empty()) {
    <button class="empty-button" lyceoButton>
      <fa-icon [icon]="faPlus" />
    </button>
  } @else {
    @if (!loading()) {
      <svg
        class="background"
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 172 117"
        preserveAspectRatio="none"
      >
        <path
          [style.fill]="icon().cssVarDark | lyceoCssVar"
          d="M0-112.618h172v250H0v-250Z"
        />
        <path
          [style.fill]="icon().cssVarLight | lyceoCssVar"
          d="m-3.936-143.794 177.979 2.887 3.02 201.61L45.838 86.796c-12.675 2.52-25.343-4.363-30.127-16.367L-1.37 27.56l-2.566-171.355Z"
        />
      </svg>
    }
    <div class="subject-name-container">
      <span class="subject-name">
        @if (loading()) {
          <lyceo-skeleton-text class="subject-name-loading" />
        } @else {
          {{ subjectName() }}
        }
      </span>
      @if (graduationIcon()) {
        <div class="extra-icon">
          <fa-icon [icon]="faGraduationCap" />
        </div>
      }
      @if (bookIcon()) {
        <div class="extra-icon">
          <fa-icon [icon]="faBook" />
        </div>
      }
    </div>
    @if (!loading()) {
      <lyceo-subject-icon
        class="subject-icon"
        [style.--trix-practise-card-icon-offset]="icon().bottomOffset + 'px'"
        [subjectName]="subjectName()"
      />
    }
  }
</div>
<div class="progress-container">
  @if (!empty()) {
    <span class="progress-title label-large">
      @if (loading()) {
        <lyceo-skeleton-text class="progress-title-loading" />
      } @else {
        {{ progressTitle() }}
      }
    </span>
    @if (loading()) {
      <lyceo-skeleton-text class="progress-bar-loading" />
    }
    @if (total() && !loading()) {
      <lyceo-progress-bar
        [progress]="progress()"
        [total]="total()"
        [showText]="false"
      />
    }
  }
</div>
